/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface Notification {
  readonly id: string;
  readonly type: string;
  readonly title: string;
  readonly body: string | null;
  readonly entity: string | null;
  readonly entityId: string | null;
  readonly readAt: string | null;
  readonly createdAt: string;
}

const BASE = '/notifications';

export const notificationsApi = {
  async list(): Promise<readonly Notification[]> {
    const { data } = await apiClient.get<readonly Notification[]>(BASE);
    return data;
  },
  async unreadCount(): Promise<number> {
    const { data } = await apiClient.get<{ count: number }>(`${BASE}/unread-count`);
    return data.count;
  },
  async markRead(id: string): Promise<void> {
    await apiClient.patch(`${BASE}/${id}/read`);
  },
  async markAllRead(): Promise<void> {
    await apiClient.patch(`${BASE}/read-all`);
  },
};
